const LOG_VERBS = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  EDITED: 'EDITED',
  ACCEPTED: 'ACCEPTED',
  DONE: 'COMPLETED',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  FEEDBACK_PROVIDED: 'FEEDBACK_PROVIDED',
  QUOTE_ADDED: 'QUOTE_ADDED',
  QUOTE_SENT: 'QUOTE_SENT',
  QUOTE_DETAILS_PROVIDED: 'QUOTE_DETAILS_PROVIDED',
  QUOTE_ACCEPTED: 'QUOTE_ACCEPTED',
  QUOTE_EXPIRED: 'QUOTE_EXPIRED',
  QUOTE_REJECTED: 'QUOTE_REJECTED',
  QUOTE_FEEDBACK_PROVIDED: 'QUOTE_FEEDBACK_PROVIDED',
  USER_INTEREST_REVALIDATED: 'USER_INTEREST_REVALIDATED',
  NOTIFICATION_SEND_FAILED: 'NOTIFICATION_SEND_FAILED',
  QUOTE_NOTIFICATION_SEND_FAILED: 'QUOTE_NOTIFICATION_SEND_FAILED',
  DELAYED: 'DELAYED',
  DELIVERED: 'DELIVERED',
  ON_THE_WAY: 'ON_THE_WAY',
  PICKUP: 'PICKUP',
  TICKET_BID_RECEIVED: 'TICKET_BID_RECEIVED',
  AUCTION_REJECTED: 'AUCTION_REJECTED',
  AUCTION_STARTED: 'AUCTION_STARTED',
  AUCTION_CLOSED: 'AUCTION_CLOSED',
  COMMENTED: 'COMMENTED',
  INTEGRATION_STATUS_UPDATE: 'INTEGRATION_STATUS_UPDATE',
};

export default LOG_VERBS;
